<!--2020-10-22/Stephen/课程选择页面UI调整-->
<div class="solid-card_wrap">
  <!-- item.state === 1表示该公司为有效的 -->
  <div *ngFor="let item of cardList;let i = index;">
    <div *ngIf="item.state === 1" (click)="handleItemClick(item.id,item.type)" class="solid-card-box" [ngClass]="{'open': item.type === 'open','experience': item.type === 'experience','company': item.type === 'company'}">
      <div class="solid-card-box_left">
        <div class="words">
          <div class="title" *ngIf="item.type === 'company'">
            {{ item.name }}
          </div>
          <div class="title" *ngIf="item.type !== 'company'">
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="solid-card-box_right">
        <img src="{{assetsRoute}}/picture/course-types/{{item.type}}.png" alt="" />
      </div>
    </div>
  </div>

</div>

<!--<div class="solid-card_wrap"> -->
<!--	&lt;!&ndash; item.state === 1表示该公司为有效的 &ndash;&gt;-->
<!--	<div *ngFor="let item of cardList;let i = index;">-->
<!--		<div *ngIf="item.state === 1" (click)="handleItemClick(item.id)" class="solid-card-box">-->
<!--			<div class="solid-card-box_left">-->
<!--				<div [className]="'icon ' + item.type"></div>-->
<!--				<div class="words">-->
<!--					<div class="title">-->
<!--						{{ item.title }}-->
<!--					</div>-->
<!--					<div *ngIf="item.description" class="description">-->
<!--						{{ item.description | limiteWordsCount:256}}-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
<!--			<div class="solid-card-box_right">-->
<!--				>-->
<!--			</div>-->
<!--		</div>-->
<!--	</div>-->
<!--	-->
<!--</div>-->



// WEBPACK FOOTER //
// ./src/component-ui/solid-card/component.html